<template>
  <v-expansion-panels :value="null">
    <v-expansion-panel>
      <v-expansion-panel-header class="expansion-panel-border green">
        <v-row>
          <v-icon>settings</v-icon>
          <h3 class="title text-uppercase ml-3">
            Пакети
          </h3>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row>
          <v-col>
            <SimpleTable
              :headers="columns"
              :height="'auto'"
              :table-shadow="false"
              :items-per-page="packages.length"
              hide-default-footer
              :items="packages"
              is-data-list-heading
              :heading-config="headingConfig"
              @search="getSearch"
            >
              <template v-slot:filters>
                <v-row dense>
                  <v-col cols="auto">
                    <v-radio-group
                      v-model="saleOption"
                      row
                      class="ml-1 mt-3 mb-n6"
                    >
                      <v-radio
                        v-for="(saleOptionType, index) in saleOptionTypes.length"
                        :key="index"
                        :label="saleOptionTypes[saleOptionType-1].label"
                        :value="saleOptionTypes[saleOptionType-1].value"
                      />
                    </v-radio-group>
                  </v-col>
                </v-row>
              </template>
            </SimpleTable>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import useVatTypes from "../../../helpers/useVatTypes";
import SimpleTable from "@/components/story/SimpleTable";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    SimpleTable,
  },
  data: () => ({
    columns: [
      { text: "id", value: "id" },
      { text: "Найменування", value: "title", rowType: "wide" },
      { text: "Aртикул", value: "article", rowType: "wide" },
      { text: "Вартість, грн без ПДВ", value: "amount", type: "decimal" },
      { text: "Вартість, грн з ПДВ", value: "amountWithVAT", type: "decimal" },
      { text: "Годин за базовим тарифом:", value: "baseRateHours" },
    ],
    saleOption: "",
    headingConfig: {
      label: "Пакети сплати",
      divider: true,
      searchField: true,
      disabledAdding: true,
    },
    search: "",
    loading: false,
  }),
  computed: {
    ...mapState("client", ["packages"]),
    saleOptionTypes() {
      return [
        { value: "null", label: "Всі" },
        { value: 0, label: useVatTypes.WITH_VAT.title },
        { value: 1, label: useVatTypes.WITHOUT_VAT.title },
        { value: 2, label: useVatTypes.BOTH_VAT.title },
      ];
    },
    filter() {
      if (this.saleOption === "null") {
        return {
          saleOptions: "",
          search: this.search,
        };
      }
      if (this.saleOption || this.saleOption === 0) {
        return {
          saleOptions: this.saleOption,
          search: this.search,
        };
      } else {
        return {
          saleOptions: "",
          search: this.search,
        };
      }
    },
  },
  watch: {
    saleOption: {
      handler(val){
        if (val === "") {
          this.saleOption = "null";
        }
        this.getPackages(this.filter);
      },
    },
    search: {
      handler(){
        this.getPackages(this.filter);
      },
    },
  },
  async created() {
    this.loading = true;
    this.saleOption = "null";
    await this.getPackages(this.filter);
    this.loading = false;
  },
  methods: {
    ...mapActions("client", ["getPackages"]),
    getSearch(search) {
      this.search = search;
    },
  },
};
</script>